import React from 'react';
import { Button, Modal } from 'components';
import { useTranslation } from 'react-i18next';
import { useUpgradeTierModalStore } from 'stores/upgradeTierModalStore';
import RamblaLogo from 'assets/img/rambla-icon.png';
import styled from 'styled-components';
import { Image } from 'react-bootstrap';

export default function UpgradeTierModal() {
  const { t } = useTranslation();
  const { isOpen, resourceType, currentLimit, upgradeUrl, closeUpgradeTierModal } =
    useUpgradeTierModalStore();

  const handleUpgrade = () => {
    if (upgradeUrl) {
      window.open(upgradeUrl, '_blank');
    }
    closeUpgradeTierModal();
  };

  const handleClose = () => {
    closeUpgradeTierModal();
  };

  if (!isOpen) return null;

  return (
    <Modal open={isOpen} onClose={handleClose} closeOnDocumentClick={false} closeButton={false}>
      <ModalContentWrapper>
        <LogoWrapper>
          <Image src={RamblaLogo} alt="Rambla Logo" width="100%" />
        </LogoWrapper>

        <Title>{t('upgradeTier:title')}</Title>

        <Description>
          {t('upgradeTier:description', {
            resourceType: t(`upgradeTier:resources.${resourceType}`, resourceType),
          })}
        </Description>

        <ResourceInfo>
          {t('upgradeTier:resourceLimit', {
            resourceType: t(`upgradeTier:resources.${resourceType}`, resourceType),
          })}
          {currentLimit && (
            <>
              {' '}
              <p>
                ({currentLimit} {t('upgradeTier:max')})
              </p>
            </>
          )}
        </ResourceInfo>

        <Description>
          {t('upgradeTier:contactInfo', {
            resourceType: t(`upgradeTier:resources.${resourceType}`, resourceType),
          })}
        </Description>

        <ButtonGroup>
          <Button variant="secondary" onClick={handleClose}>
            {t('app:cancel')}
          </Button>
          {upgradeUrl && (
            <Button variant="primary" onClick={handleUpgrade}>
              {t('upgradeTier:upgradeButton')}
            </Button>
          )}
        </ButtonGroup>
      </ModalContentWrapper>
    </Modal>
  );
}

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 400px;
  gap: 8px;
  color: #181818;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 196px;
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: bold;
`;

const Description = styled.p`
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 0;
`;

const ResourceInfo = styled.div`
  margin: 12px 0;
  padding: 12px 16px;
  background-color: #f2f4f6;
  border: 1px solid #ced4da;

  p {
    display: inline-block;
    margin: 0;
    color: #be1622;
    font-weight: bold;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  width: 100%;

  button {
    min-width: 140px;
  }
`;
